import React from 'react';
import * as AiIcons from 'react-icons/ai';
import * as BiIcons from 'react-icons/bi';
import * as BsIcons from 'react-icons/bs';
import * as CiIcons from 'react-icons/ci';
import * as FaIcons from 'react-icons/fa';
import * as GrIcons from 'react-icons/gr';
import * as HiIcons from 'react-icons/hi';
import * as MdIcons from 'react-icons/md';
import * as RiIcons from 'react-icons/ri';
import * as TbIcons from 'react-icons/tb';
import * as TfiIcons from 'react-icons/tfi';
import * as GoIcons from 'react-icons/go';

export function DynamicIcon({ iconName, fallbackName }) {
  const getInitials = (name, maxLetters = 3) => {
    if (!name) return '';
    const words = name.trim().split(' ').filter(Boolean);
    const initials = words
      .map((word) => word[0])
      .join('')
      .toUpperCase();
    return initials.substring(0, maxLetters);
  };

  if (!iconName) {
    return <>{getInitials(fallbackName)}</>;
  }

  const iconLibraries = {
    Ai: AiIcons,
    Bi: BiIcons,
    Bs: BsIcons,
    Ci: CiIcons,
    Fa: FaIcons,
    Gr: GrIcons,
    Hi: HiIcons,
    Md: MdIcons,
    Ri: RiIcons,
    Tb: TbIcons,
    Tfi: TfiIcons,
    Go: GoIcons,
  };

  const libraryPrefixMatch = iconName.match(/^([A-Za-z]+?)(?=[A-Z])/);
  if (!libraryPrefixMatch) {
    console.warn(`Formato inválido de nome de ícone: ${iconName}`);
    return <>{getInitials(fallbackName)}</>;
  }

  const libraryPrefix = libraryPrefixMatch[1];
  const IconLibrary = iconLibraries[libraryPrefix];

  if (!IconLibrary) {
    console.warn(`Biblioteca de ícones não encontrada para o prefixo: ${libraryPrefix}`);
    return <>{getInitials(fallbackName)}</>;
  }

  const IconComponent = IconLibrary[iconName];

  if (!IconComponent) {
    console.warn(`Ícone não encontrado: ${iconName} na biblioteca ${libraryPrefix}`);
    return <>{getInitials(fallbackName)}</>;
  }

  return <IconComponent />;
}
